<template>
  <a-drawer width="60%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">

      <!--选择商品-->
      <a-form-model-item :label="$t('通用.文本.选择商品')" prop="goodsId">
        <a-button type="primary" @click="openProdSelect" danger>
          <span>选择秒杀商品</span>
        </a-button>
      </a-form-model-item>
      <!-- 数据展示 -->
      <a-table
        :loading="goodsLoading"
        :scroll="{ x: '100%' }"
        :size="tableSize"
        :columns="goodsColumns"
        :data-source="form.goodsList"
        rowKey="id"
        :pagination="false"
        :bordered="tableBordered">

        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <template slot="picture" slot-scope="text, record">
          <div>
            <img v-if="record.goodsPicture" :src="record.goodsPicture"  style="width:60px;height:62px;" @click="handleRecordPreview(record.goodsPicture)" alt="none"/>
          </div>
        </template>
        <span slot="livePrice" slot-scope="text, record">
            <a-input v-model="record.livePrice" :maxLength="255" @blur="editLivePrice(record)"
                     :placeholder="$t('通用.输入.请输入')+$t('直播价格')"/>
          </span>
        <span slot="status" slot-scope="text, record">
            <a-select style="width: 50%" v-model="record.status"  @change="onStatusChange(record)">
              <a-select-option v-for="(item, index) in customDict.GoodsOnOffEnum" :value="item.type"
                               :key="index">
                        {{ item.name }}
              </a-select-option>
            </a-select>
          </span>

        <span slot="recommend" slot-scope="text, record">
          <a-switch @change="(checked) => onRecommendChange(checked,record)" :checked-children="$t('是')"
                    :un-checked-children="$t('否')" :checked="record.recommend"/>
          </span>
        <span slot="operation" slot-scope="text, record">
           <a @click="handleDelete(record)">
             <a-icon type="delete" />{{$t('通用.按钮.删除')}}
           </a>
      </span>

      </a-table>

      <!--选择商品-->



      <div class="bottom-control">
        <a-space>
<!--          <a-button type="primary" :loading="submitLoading" @click="submitForm">-->
<!--            {{$t('通用.按钮.保存')}}-->
<!--          </a-button>-->
          <a-button type="dashed" @click="cancel">
            {{$t('关闭')}}
          </a-button>
        </a-space>
      </div>


      <!--选择商品-->
      <radio-goods-select-form ref="RadioGoodsSelectForm" @goodsSelect="indexGoodsModalSelect"></radio-goods-select-form>
      <!--选择商品-->

      <!-- 图片预览弹窗 -->
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="preview" style="width: 100%" :src="previewUrl" />
      </a-modal>

    </a-form-model>
  </a-drawer>
</template>

<script>
import {
  editLivePrice,
  addLive,
  updateLive,
  shopUserList,
  userList,
  getLiveGoods,
  addLiveGoods,
  deleteLiveGoods,
  shangjia,
  xiajia, editLiveRecommend,
  addSeckillGoodsToLiveRoom
} from '@/api/live/live'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject, uploadOss} from "@/api/tool/oss";

//选择商品
import RadioGoodsSelectForm from "@/views/live/live/modules/GoodsSelectForm";
import {allBrand} from "@/api/goods/brand";
import {batchOff, batchOn, listCategory} from "@/api/goods/goods";
import {updateUserStatus} from "@/api/biz/user";
//选择商品

export default {
  name: 'CreateFormGoods',
  props: {
  },
  components: {
    CustomDictTag,
    //选择商品
    RadioGoodsSelectForm
    //选择商品
  },
  data () {
    return {
      shopUserList:[],
      liveTypeList:[

          {
            value: 2,
            label: this.$t('视频直播')
          },
        {
          value: 3,
          label: this.$t('obs直播')
        },
      ], screenModeList:[
          {
            value: 1,
            label: this.$t('竖屏')
          },
        {
          value: 2,
          label: this.$t('横屏')
        },
      ],
      signList:[
        {
          value: 0,
          label: this.$t('否')
        },
        {
          value: 1,
          label: this.$t('是')
        },

      ],
        userList:[],
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      goodsLoading: false,
      tableSize: 'default',
      tableBordered: true,

      //选择商品
      categoryList:[],
      brandList:[],
      goodsColumns: [
        {
          title: this.$t('商品.商品名称'),
          dataIndex: 'goodsName',
          width: 150,
        },
        {
          title: this.$t('商品.商品主图'),
          dataIndex: 'goodsPicture',
          width: 90,
          scopedSlots: {customRender: 'picture'},
        },

        {
          title: this.$t('商品.市场价'),
          width: 100,
          dataIndex: 'goodsPrice',
        },
        {
          title: this.$t('秒杀价格'),
          width: 100,
          dataIndex: 'seckillPrice',
        },
        {
          title: this.$t('商品.商品状态'),
          dataIndex: 'status',
          width: 80,
          scopedSlots: {customRender: 'status'},
        },
        {
          title: this.$t('是否讲解中'),
          dataIndex: 'recommend',
          width: 40,
          scopedSlots: { customRender: 'recommend' },
          align: 'center'
        },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          width: 30,
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ],
      //选择商品

      // 表单参数
      form: {
        //选择商品
        goodsList: [],
        //选择商品

        id: null,

        imGroupId: null,
        goodsIds: null,
        liveId: null,

        userId: null,

        shopId: null,

        shopName: null,

        shopLogo: null,

        thumb: null,

        theme: null,

        intro: null,

        liveName: null,

        openTime: null,
        preOpenTime: null,

        closeTime: null,

        expiredTime: null,

        effective: null,

        duration: null,

        pushUrl: null,

        pullUrl: null,

        chatNum: null,

        totalMoney: null,

        status: 0,

        cutInfo: null,

        isErrorClose: null,

        errorCloseTime: null,

        classifyId: null,

        liveType: 2,
        screenMode: 1,
        showSignFlag: 0,
        isPlayback: 0,
        pubSignNum: 1,
        pubSignTime: 1,
        receiptTime: 1,
        receiptEffectiveTime:0,
        liveAddress: null,

        liveCityName: null,

        redPacketExpiredTime: null,

        redPacketBeginTime: null,

        createTime: null,

        remark: null,
        signInter:null,
        signScore:null,
        seekInter:null,
        seekScore:null,
        userShare:null,
        signShowTime:null,
        signNum:null,
        liveScreen:null,
        bitRate:null,
        flow:null,
        allowUserId:null,
        manageUserId:null,
        password:null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        imGroupId: [
          { required: true, message: this.$t('腾讯IM群ID(发起直播单独创建一个群)')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],preOpenTime: [
          { required: true, message: this.$t('预计直播开启时间')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        theme: [
          { required: true, message: this.$t('直播主题')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],  thumb: [
          { required: true, message: this.$t('直播封面')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        isErrorClose: [
          { required: true, message: this.$t('是否直播流异常,1,异常 0,正常,腾讯云直播流异常时写入')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ], pubSignTime: [
          { required: true, message: this.$t('请填写')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ], liveType: [
          { required: true, message: this.$t('直播类型')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ], allowUserId: [
          { required: true, message: this.$t('开播用户')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],manageUserId: [
          { required: true, message: this.$t('管理员')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],pubSignNum: [
          { required: true, message: this.$t('签到获取积分')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        liveScreen:[
          { required: true, message: this.$t('直播主题')+this.$t('通用.输入.请选择'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
    //选择商品
    this.getCateList();
    this.getBrandList();
    //选择商品

    this.getShopUserList();
    this.getUserList();
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },

      editLivePrice( record){
        let data = {"liveId": record.liveId,"goodsIds": record.goodsId,"livePrice": record.livePrice};
        editLivePrice(data).then( response=>{
          getLiveGoods({"id":this.form.liveId}).then(response => {
            this.form.goodsList = response.data
          })
        })
      },
    onRecommendChange(statusFlag, record){
      let data = {"liveId": record.liveId,"goodsIds": record.goodsId,"statusFlag": statusFlag};
      editLiveRecommend(data).then(response => {
        if (response.success) {
          this.$message.success(
              this.$t('通用.文本.修改成功'),
              3
          );
          this.$emit('ok')
        }
      }).finally(() => {
        getLiveGoods({"id":this.form.liveId}).then(response => {
          this.form.goodsList = response.data
        })
      })
    },
    onStatusChange(record) {
      //商品快捷上下架
      let data = {"liveId": record.liveId,"goodsIds": record.goodsId};
      if (record.status===1) {
        shangjia(data).then(() => {
          getLiveGoods({"id":this.form.liveId}).then(response => {
            this.form.goodsList = response.data
          })
          this.$message.success(
            this.$t('商品.上架成功'),
            3
          )
        })
      } else if (record.status===0) {
        xiajia(data).then(() => {
          getLiveGoods({"id":this.form.liveId}).then(response => {
            this.form.goodsList = response.data
          })
          this.$message.success(
            this.$t('商品.下架成功'),
            3
          )
        })
      }
    },


    handleDelete(row){
      deleteLiveGoods({goodsIds:row.goodsId,liveId:row.liveId}).then(response=>{
        getLiveGoods({"id":row.liveId}).then(response=>{
          this.form.goodsList = response.data
        })
      })
    },
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        //选择商品
        goodsList: [],
        //选择商品
        id: null,
        imGroupId: null,
        userId: null,
        shopId: null,
        shopName: null,
        shopLogo: null,
        thumb: null,
        theme: null,
        intro: null,
        liveName: null,
        openTime: null,
        preOpenTime: null,
        closeTime: null,
        expiredTime: null,
        effective: null,
        duration: null,
        pushUrl: null,
        pullUrl: null,
        chatNum: null,
        totalMoney: null,
        status: 0,
        cutInfo: null,
        isErrorClose: null,
        errorCloseTime: null,
        classifyId: null,
        liveType: 2,
        screenMode: 1,
        showSignFlag: 0,
        isPlayback: 0,
        pubSignNum: 1,
        pubSignTime: 1,
        receiptTime: 1,
        receiptEffectiveTime:0,
        liveAddress: null,
        liveCityName: null,
        redPacketExpiredTime: null,
        redPacketBeginTime: null,
        createTime: null,
        remark: null,
        signInter:null,
        signScore:null,
        seekInter:null,
        seekScore:null,
        userShare:null,
        signShowTime:null,
        signNum:null,
        liveScreen:null,
        bitRate:null,
        flow:null,
        allowUserId:null,
        manageUserId:null,
        password:null,
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getLiveGoods({"id":id}).then(response => {
        this.form.goodsList = response.data
        this.form.liveId = id
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateLive(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addLive(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
    limitPrice() {
      let val = this.form.signScore.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1');
      if (val == null || val == undefined || val == '' || val < 0) {
        val = ''
      }
      if (val > 21474836) {
        val = 21474836
      }
      this.form.signScore = val
    },
    limitPrice1() {
      let val = this.form.seekScore.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1');
      if (val == null || val == undefined || val == '' || val < 0) {
        val = ''
      }
      if (val > 21474836) {
        val = 21474836
      }
      this.form.seekScore = val
    },

    limitbitRate() {
      let val = this.form.bitRate.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1');
      if (val == null || val == undefined || val == '' || val < 0) {
        val = ''
      }
      if (val > 21474836) {
        val = 21474836
      }
      this.form.bitRate = val
    },

    // oss 上传开始
    async handlePreview(file) {
      let suffix = file.name.substring(file.name.lastIndexOf('.'));
      if (suffix === '.mp4') {
        this.handleVideoPreview(file);
      } else {
        this.handleImagePreview(file);
      }
    },

    async handleVideoPreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewVideoVisible = true
    },
    async handleImagePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewImageVisible = true
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = error => reject(error)
    })
    },
    // 上传之前校验
    beforeOssUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 20
      // if (!isJPG) {
      //     this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 20MB!')
      }
      return isLt2M
    },
    // 上传覆盖默认的上传行为
    coverImgUpload(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'thumb'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
        _this.$set(_this.form, 'thumb', res)
      _this.$message.success(this.$t('通用.文本.上传成功'),)
    })
    })
    },
    coverDetailImgUpload(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'live'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
        _this.$set(_this.form, 'detailImg', res)
      _this.$message.success(this.$t('通用.文本.上传成功'),)
    })
    })
    },
    // oss 上传结束

    //选择商品
    indexGoodsModalSelect(records) {
      console.log('选择的秒杀商品 records:', records)
      // 调用接口将秒杀商品添加到直播间
      const seckillIds = records.map(e => e.id)
      const param = {
        liveId: this.form.liveId,
        seckillIds: seckillIds,
        recommend: 0
      }
      addSeckillGoodsToLiveRoom(param).then(response => {
        console.log('添加秒杀商品响应:', response)
        this.$message.success('添加秒杀商品成功')
        // 刷新商品列表
        return getLiveGoods({ id: this.form.liveId })
      }).then(response => {
        console.log('刷新商品列表响应:', response)
        this.form.goodsList = response.data
      })
    },
    openProdSelect() {
      // 只传递有效的goodsId，避免传入null导致错误
      const selectedIds = this.form.goodsId ? [this.form.goodsId] : [];
      this.$refs.RadioGoodsSelectForm.openGoods(undefined, selectedIds);
    },
    //选择商品


    getBrandNameById(id) {
      if (!id) {
        return "";
      }
      let brandInfo = this.brandList.find(e => e.id === id);
      if (brandInfo) {
        return brandInfo.name
      } else {
        return "";
      }
    },
    getCategoryNameById(id) {
      if (!id) {
        return "";
      }
      let cateInfo = this.categoryList.find(e => e.id === id);
      if (cateInfo) {
        return cateInfo.categoryName
      } else {
        return "";
      }
    },
    getCateList() {
      listCategory().then(response => {
        this.categoryList = response.data;
      })
    },
    getBrandList() {
      allBrand().then(response => {
        this.brandList = response.data
    })
    },
    //选择商品


    //查询店铺用户列表
    getShopUserList() {
      shopUserList().then(response => {
        this.shopUserList = response.data
    })
    },
      getUserList() {
          userList().then(response => {
        this.userList = response.data
    })
    },

  }
}
</script>
